import { styled } from '@mui/material/styles';
import { Box, Paper, Fab, TextField, Drawer } from '@mui/material';

export const RootContainer = styled('div')(({ theme }) => ({

}));

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  width: 240,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: 240,
  },
}));

export const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  margin: 0,
  flexGrow: 1,
  padding: 0,
}));

export const TableContainer = styled('div')(({ theme }) => ({
  width: "100%",
  height: "auto",
  overflowX: "auto",
  '& > *': {
    height: '100%',
  }
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: 0,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const ActionFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));

export const FilterSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const FilterButton = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const SearchField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const Toolbar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
})); 